import { useMutation } from '@tanstack/react-query';

import backendService from '../services/backendService';

export const useGenerateStandardFromSearch = () => {
  const { mutate: generate, data, isLoading, reset } = useMutation(
    ['generateLearningStandard'],
    backendService.instance.generatorPlugin.generateLearningStandard,
  );

  return {
    generate,
    data,
    isLoading,
    reset,
  };
};
